import React, { ReactNode, useEffect } from 'react';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import { SUPPORTED_FIVERR_LOCALES_KEYS } from '@fiverr-private/localization';
import AppContext from '../../context/AppContext';
import { sendMixPanelEvent } from '../../utils/biEvents';
import { MP_SHOW_PAGE_NAME } from '../../utils/biEvents/events/mixPanelEvents';
import { MIXPANEL_EVENT_TYPES } from '../../utils/types/mixpanelEventTypes';

import './style.scss';

interface EntryWrapperProps {
    removeBottomSpace?: boolean;
    withEnglishBAL?: boolean;
    isTiktokShopActive?: boolean;
    children?: ReactNode;
}

const EntryWrapper = ({
    removeBottomSpace = false,
    withEnglishBAL = false,
    isTiktokShopActive = false,
    children,
}: EntryWrapperProps) => {
    const { locale, isMobile } = getContext();

    useEffect(() => {
        sendMixPanelEvent({
            eventName: MP_SHOW_PAGE_NAME,
            eventType: MIXPANEL_EVENT_TYPES.PAGE_VIEW,
        });
    }, []);
    const context = {
        withEnglishBAL,
        isTiktokShopActive,
    };

    const shouldApplyStyles = locale === SUPPORTED_FIVERR_LOCALES_KEYS.EN_US && !isMobile;

    return (
        <div
            className={classNames('logged-out-homepage', 'is-revamp', {
                'p-b-0': removeBottomSpace,
                'logged-out-homepage-de': locale === SUPPORTED_FIVERR_LOCALES_KEYS.DE_DE,
                'logged-out-homepage-test': shouldApplyStyles,
            })}
        >
            <AppContext.Provider value={context}>{children}</AppContext.Provider>
        </div>
    );
};

export default EntryWrapper;
